<template>
  <v-menu offset-x left transition="slide-x-reverse-transition" :close-delay='300' :open-delay='200'>
    <template v-slot:activator='{ on }'>
      <v-btn icon v-on='on'>
        <v-icon>{{ menuIcon }}</v-icon>
      </v-btn>
    </template>
    <v-list nav dense>
      <slot></slot>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'wc-burger-menu',
  props: {
    menuIcon: {
      required: false,
      default: 'mdi-menu'
    }
  }
}
</script>
